import { getIncreaseBudgetBuilder } from "./increaseBudget";
/**
 * Execute a transaction group with automatic budget increase.
 */
export async function executeTxns({ txnBuilder, txnBuilderArgs, emptyGroupBuilder, sendParams, writerAccount, algod, }) {
    let builder = await txnBuilder(txnBuilderArgs);
    const increasedBudgetBuilder = await getIncreaseBudgetBuilder(builder, emptyGroupBuilder, writerAccount.sender.toString(), writerAccount.signer, algod);
    if (increasedBudgetBuilder)
        builder = await txnBuilder({ ...txnBuilderArgs, builder: increasedBudgetBuilder });
    return builder.send(sendParams);
}
/**
 * Create a makeTxnExecutor factory bound to a specific SDK instance.
 * Returns a function with the same signature as the per-SDK makeTxnExecutor.
 */
export function createTxnExecutor(sdkInstance, emptyGroupBuilder, wrapErrorsFn, getWriterAccount, getAlgod) {
    return ({ maker, returnTransformer, sendParams, }) => {
        return async (args) => {
            const writerAccount = getWriterAccount();
            if (!writerAccount) {
                throw new Error(`writerAccount not set on the SDK instance`);
            }
            const result = await wrapErrorsFn(executeTxns({
                txnBuilder: (args) => maker.bind(sdkInstance)(args),
                txnBuilderArgs: args,
                emptyGroupBuilder,
                sendParams,
                writerAccount,
                algod: getAlgod(),
            }));
            if (returnTransformer) {
                return returnTransformer(result);
            }
            return result;
        };
    };
}
